export default "__VITE_ASSET__Cwew4pJU__"